import React from 'react'

const withForwardingRef = Component =>
  React.forwardRef((props, ref) => <Component { ...props } forwardedRef={ ref } />)

export default withForwardingRef
